"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactForm = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const forms_service_ui_1 = require("@danfoss/forms-service-ui");
const app_1 = require("app");
const React = require("react");
const ContactForm_1 = require("../../Components/ContactForm");
const ContactLoadingPopupContent_1 = require("./ContactLoadingPopupContent");
const trackFormOpening = () => {
    // Remove trailing slash to handle cases with and without it
    const urlPath = window.location.pathname.replace(/\/$/, '');
    app_1.GTM.contactFormOpen({
        virtualPageUrl: `${urlPath}/contact-form/virtual`,
        virtualPageTitle: 'Contact Form | Danfoss',
        segment: '',
        subSegment: '',
        pageType: 'contactForm',
    });
};
const ContactForm = ({ contactId, culture, dictionary, locationApiUrl, formsServiceApiUrl, contactFormService, onFormClose, }) => {
    const [contactData, setContactData] = React.useState(null);
    const [showErrorMessage, setShowErrorMessage] = React.useState(false);
    const [additionalData, setAdditionalData] = React.useState({
        formAlias: null,
        companyNameUI: null,
    });
    (0, app_1.useDidMount)(() => {
        trackFormOpening();
        contactFormService.getContactById(contactId).then(([contact]) => {
            if (!contact) {
                setShowErrorMessage(true);
                return;
            }
            const { type: contactType, segments, country, email, companyName } = contact;
            const formAlias = (0, forms_service_ui_1.getFormAlias)({ contactType, segments, country, email });
            const hasContactForm = !!formAlias;
            if (!hasContactForm) {
                setShowErrorMessage(true);
                return;
            }
            setAdditionalData({ formAlias, companyNameUI: companyName });
            setContactData(contact);
        }, () => {
            setShowErrorMessage(true);
        });
    });
    const { formAlias, companyNameUI } = additionalData;
    const contactLoadingFormTitle = dictionary.formTitleMessage;
    const contactLoadedFormTitle = `${dictionary.formTitleMessage} ${companyNameUI}`;
    const formTitle = React.useMemo(() => {
        if (showErrorMessage)
            return '';
        return contactData ? contactLoadedFormTitle : contactLoadingFormTitle;
    }, [contactData, contactLoadedFormTitle, contactLoadingFormTitle, showErrorMessage]);
    return ((0, jsx_runtime_1.jsx)(ContactForm_1.ContactFormPopup, { formAlias: formAlias, formTitle: formTitle, onModalExited: onFormClose, popupOpenedAriaLabel: dictionary.contactFormPopupOpenedLabel, closeButtonAriaLabel: dictionary.popupCloseBtnLabel, children: (contactFormState, setFormState) => contactData ? ((0, jsx_runtime_1.jsx)(ContactForm_1.ContactFormPopupContent, { formAlias: formAlias, contactData: contactData, companyName: companyNameUI, formTitle: contactLoadedFormTitle, dictionary: dictionary, culture: culture, locationUrl: locationApiUrl, formServiceUrl: formsServiceApiUrl, contactFormState: contactFormState, setFormState: setFormState })) : ((0, jsx_runtime_1.jsx)(ContactLoadingPopupContent_1.ContactLoadingPopupContent, { showErrorMessage: showErrorMessage, genericErrorMessageText: dictionary.genericErrorMessage })) }));
};
exports.ContactForm = ContactForm;
exports.default = exports.ContactForm;
